
import Vue from "vue";
import { BContainer, BForm, BFormGroup } from "bootstrap-vue";
import { Component } from "vue-property-decorator";
import AuthModel from "@/models/AuthModel";
import OtpModel from "@/models/OtpModel";
import { UserModule } from "@/store/modules/user";
import TextInput from "@/components/input/TextInput.vue";
import AlertBox from "@/components/AlertBox.vue";
import router from "@/router";
import api from "@/api";
import { ValidationObserver, ValidationProvider } from "vee-validate";
@Component({
  components: {
    BContainer,
    TextInput,
    BForm,
    BFormGroup,
    ValidationObserver,
    ValidationProvider,
    AlertBox,
  },
})
export default class Auth extends Vue {
  mounted() {
    this.errorDialogState = false;
    // firebase
    //   .messaging()
    //   .getToken()
    //   .then((token) => {
    //     // console.log("token firebase", token);
    //     // TODO save token to backend
    //     this.tokenFcm = token;
    //     // this.receiveMessage();
    //   })
    //   .catch((err: any) => {
    //     // console.log(err);
    //     this.$swal("Error", err?.response?.data?.message, "error");
    //   });
  }
  userToken: string | null = null;
  tokenFcm: string = "000";
  email: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  otp: string = "";
  displayLogin = true;
  displayResetPassword = false;
  displayOtp = false;
  displayChangePassword = false;
  errorDialogState = false;
  errorDialogDescription = "Login Gagal";
  auth: AuthModel = new AuthModel();
  otpMod: OtpModel = new OtpModel();
  validToken = true;

  onLogin() {
    this.errorDialogState = false;
    this.auth.firebase_token = this.tokenFcm;
    if (this.auth.email && this.auth.password && this.auth.firebase_token) {
      UserModule.Login(this.auth)
        .then(() => {
          api.user
          .getUserDetail()
          .then((response) => {
            if (response.data.code === 200) {
              if(response.data.data.access_group_id == "6"){
                return router.push({ name: "utilities" });
              }
              return router.push({ name: "home" });
            }
          })
        })
        .catch(() => {
          this.errorDialogState = true;
        });
    }
  }
  logout() {
    this.errorDialogState = false;
    UserModule.Logout().then(() => {
      router.push({ name: "Splash" });
    });
  }
  forgotPassword() {
    this.displayLogin = false;
    this.displayResetPassword = true;
    this.displayOtp = false;
    this.displayChangePassword = false;
  }
  onResetEmail() {
    if (this.email) {
      api.auth
        .forgetPassword(this.email)
        .then((response) => {
          if (response.data.code === 200) {
            this.$swal("Berhasil", "Otp terkirim ke email Anda!", "success");
            this.displayLogin = false;
            this.displayResetPassword = false;
            this.displayOtp = true;
            this.displayChangePassword = false;
          } else {
            this.$swal("Peringatan", response.data.message, "warning");
          }
        })
        .catch((err: any) => {
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    }
  }
  onSendOtp() {
    if (this.email && this.otp) {
      api.auth
        .verification(this.email, this.otp)
        .then((response) => {
          if (response.data.code === 200) {
            this.otpMod = Object.assign({}, response.data.data);
            this.displayLogin = false;
            this.displayResetPassword = false;
            this.displayOtp = false;
            this.displayChangePassword = true;
            this.email = "";
            this.otp = "";
          } else {
            this.$swal("Peringatan", response.data.message, "warning");
          }
        })
        .catch((err: any) => {
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    }
  }
  onSavePassword() {
    if (this.newPassword && this.confirmPassword && this.otpMod.jwt_token) {
      api.auth
        .resetPassword(
          this.newPassword,
          this.confirmPassword,
          this.otpMod.jwt_token
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.$swal("Berhasil", "Ubah password berhasil!", "success");
            this.displayLogin = true;
            this.displayResetPassword = false;
            this.displayOtp = false;
            this.displayChangePassword = false;
            this.newPassword = "";
            this.confirmPassword = "";
          } else {
            this.$swal("Peringatan", response.data.message, "warning");
          }
        })
        .catch((err: any) => {
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    }
  }
  isTokenComplete(event) {
    if (event === false) {
      this.validToken = true;
    } else {
      this.validToken = false;
    }
  }
}
